module.exports = __webpack_public_path__ + "img/fi-rr-cursor-text-alt.270d3c87.svg";